import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "small me-2" }, "Ordenado por:", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortConfiguration, (sortedColumn) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: sortedColumn }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedColumn, (filter) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "badge rounded-pill bg-secondary me-2",
            key: filter
          }, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.getUserFriendlyColumnName(filter[0])) + " ", 1),
              _createElementVNode("i", {
                role: "button",
                class: _normalizeClass(_ctx.sortOrderIconClass(filter[0], filter[1])),
                onClick: ($event: any) => (
            _ctx.updateSortConfiguration(
              filter[0],
              filter[1] === 'asc' ? 'desc' : 'asc'
            )
          )
              }, null, 10, _hoisted_1)
            ]),
            _createElementVNode("i", {
              class: "fa fa-times-circle ms-2",
              "aria-hidden": "true",
              role: "button",
              onClick: ($event: any) => (_ctx.updateSortConfiguration(filter[0], filter[1]))
            }, null, 8, _hoisted_2)
          ]))
        }), 128))
      ], 64))
    }), 128))
  ], 64))
}